import './App.css';
import { ToastContainer } from 'react-toastify';
import Routers from './components/Routers';


function App() {
  return (
    <>
    <Routers/>
    <ToastContainer/>
    </>
  );
}

export default App;